@if(loader){
    <app-loader></app-loader>
}
<p-card header="Receive Purchase Order List">

        <div class="flex mb-1 justify-content-between">
            <div>
                <span class="p-input-icon-left ml-auto" style="position: absolute; left: 50%;">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="Search keyword" class=" p-inputtext-sm" />
                </span>
            </div>
        </div>
        <br>
        <div class="mt-5">
        <p-table #dt1 [value]="result.purchaseOrder" [scrollable]="true" scrollHeight="350px"
            styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
            [paginator]="true" [rows]="5" (onPage)="loadPOrder($event)" [(selection)]="selectedPOrder" [globalFilterFields]="['purchaseOrderNumber','vendor.vendorCode','vendor.vendorName','poTotal','requestedDate']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[5, 10, 20]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <!-- <p-tableHeaderCheckbox></p-tableHeaderCheckbox> -->
                    </th>
                    <th>Purchase Order No</th>
                    <th>Vendor Code</th>
                    <th>Vendor Name</th>
                    <th>PO Total</th>
                    <th>Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-purchaseOrder>
                <tr>
                    <td>
                        <!-- <p-tableCheckbox [value]="purchaseOrder"></p-tableCheckbox> -->
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editPOrder(purchaseOrder.purchaseOrderId)">
                        {{purchaseOrder.purchaseOrderNumber}}
                    </td>
                    <td>{{purchaseOrder.vendorCode}}</td>
                    <td>{{purchaseOrder.vendor.vendorName}}</td>
                    <td>₹ {{ purchaseOrder.poTotal| number }}</td>
                    <td>{{purchaseOrder.requestedDate | date: 'dd/MM/yyyy' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
